import { useState, useEffect } from "react";
import {
  Typography,
  Form,
  message,
  Row,
  Col,
  Divider,
  Input,
  Button,
  Card,
} from "antd";
import { useParams } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { css } from "@emotion/css";

import { updatePasswordAction } from "../store/action/shared/authAction";
// import CountModal1 from "../shared-components/countdown/index";
import { keyframes } from "emotion";
import CustomLoaderIcon from "../Theme/CustomIcons/Icons/Essetional/CustomLoaderIcon";
const fadeInAndFloat = keyframes`
  0% {
    opacity: 0;
    transform: translateY(10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

const floatingAnimation = keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
`;

const cardStyle = css`
  animation: ${fadeInAndFloat} 1s forwards,
    ${floatingAnimation} 3s ease-in-out infinite;
`;
const { Title } = Typography;
function ResetPassCard() {
  const search = useLocation().search;
  const otp = new URLSearchParams(search).get("otp");
  if (otp) {
    localStorage.setItem("otp", JSON.stringify(otp, null, " "));
  }

  const dispatch = useDispatch();
  const { email } = useParams();
  const router = useNavigate();

  const updatePassword = useSelector((state) => state.updatePassword);
  const { loading, error } = updatePassword;
  const [ResetPassModal, setResetPassModal] = useState(false);

  const [form] = Form.useForm();
  const onFinish = async (values) => {
    if (values.confirmPassword === values.password) {
      try {
        await dispatch(updatePasswordAction(values));
        form.resetFields();
        localStorage.removeItem("otp");
        message.success("New password updated successfully");
        router(`/login`);
      } catch (error) {
        message.error("Please try again later");
        message.error("Try again later!");
      }
    } else {
      message.error("confirm password doesn't same");
    }
  };
  const otps = localStorage.getItem("otp");
  let otping = "";
  if (otps) {
    otping = otps.replace(/['"]+/g, "");
  }
  useEffect(() => {
    const otp = JSON.parse(localStorage.getItem("otp"));
    if (otp) {
      router(`/reset/${email}`, { replace: true });
    }
  }, []);

  return (
    <Row
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Col span={8}>
        <Card
          className={cardStyle}
          style={{
            borderRadius: "32px",
            padding: "30px",
          }}
        >
          <Row>
            <Col span={24}>
              <Title>Change your Password</Title>
              <p className="subtitle-Body-Large-Subtle subtitle-Body-Large-padding">
                Streamline your Time and Productivity
              </p>
              <Divider className="form-divider" />
              <div style={{ display: "flex", justifyContent: "center" }}>
                <p>This link will expire soon!</p>
              </div>
            </Col>
            <Col span={24}>
              <Form
                form={form}
                name="normal_login"
                className="login-form"
                layout="vertical"
                autoComplete="on"
                initialValues={{
                  email: email,
                  otp: otping,
                  remember: true,
                }}
                onFinish={onFinish}
              >
                <Row gutter={[0, 0]}>
                  <Col span={24}>
                    <Form.Item
                      name="confirmPassword"
                      label="Confirm Password*"
                      rules={[
                        {
                          required: true,
                          message: "Please input your confirm password",
                        },
                      ]}
                    >
                      <Input.Password
                        type="password"
                        placeholder="Enter your confirm password"
                        className={css`
                          padding: 11px 12px !important;
                        `}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      name="password"
                      label="New Password*"
                      rules={[
                        {
                          required: true,
                          message: "Please input your New Password",
                        },
                      ]}
                    >
                      <Input.Password
                        type="password"
                        placeholder="Enter your New Password"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item name="otp">
                      <Input type="hidden" placeholder="Enter your otp" />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item name="email" label="">
                      <input type="hidden" />
                    </Form.Item>
                  </Col>

                  {error && <p style={{ color: "red" }}>{error}</p>}
                  <Col span={24} style={{ marginTop: 10 }}>
                    <Form.Item>
                      <Button
                        type="primary"
                        htmlType={loading ? "button" : "submit"}
                        loading={loading}
                      >
                        Change Password
                      </Button>
                    </Form.Item>
                  </Col>

                  <Col span={24} align="left">
                    <p
                      className="spacer-medium"
                      style={{ fontSize: 14, fontWeight: 600 }}
                    >
                      Back to{" "}
                      <Link to="/forgot-password">
                        <span style={{ color: "#f47e63" }}>
                          Forgot Password
                        </span>
                      </Link>
                    </p>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </Card>
      </Col>{" "}
      {/* <CountModal1
        setIsModalVisible={setResetPassModal}
        isModalVisible={ResetPassModal}
      /> */}
    </Row>
  );
}

export default ResetPassCard;
